module.exports = __webpack_public_path__ + "static/why-hexomatic-sm-f3e029b2de377a8d4618ce80e06c506f.png";